export class SearchType {
  static Procedure = 'Procedure';
  static Doctor = 'Doctor';
  static Facility = 'Facility';
  static ByUniqueId = 'ByUniqueId';
}
